import React from 'react';
import { Users, Eye } from 'lucide-react';

const PropertyCard = ({ property, onClick }) => {
  return (
    <div
      onClick={() => onClick(property.id)}
      className="bg-white border border-notion-border rounded-xl p-3 shadow-card flex gap-3 cursor-pointer active:border-stone-300"
    >
      <div
        className="w-16 h-16 bg-stone-200 rounded-lg flex-shrink-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${property.image}')` }}
      ></div>
      <div className="flex-1 min-w-0">
        <h3 className="font-semibold text-sm text-notion-text truncate">{property.address.split(',')[0]}</h3>
        <p className="text-xs text-stone-500 mt-0.5">{property.address.split(',')[1]?.trim()} • {property.price}</p>
        <div className="flex items-center gap-2 mt-2">
          <span className="text-[10px] text-stone-400 flex items-center gap-1">
            <Users className="w-3 h-3" /> {property.leads} Leads
          </span>
          {property.views > 0 && (
            <span className="text-[10px] text-stone-400 flex items-center gap-1">
              <Eye className="w-3 h-3" /> {property.views} Views
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
